import './App.css';

import * as Sentry from '@sentry/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { lazy, Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import EnvironmentBanner from './components/EnvironmentBanner';
import { router } from './router';

// Define a loader component for suspense fallback
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
);

// Test component to verify Sentry is working
export const SentryTestButton = () => {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first Sentry error!');
      }}
      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
    >
      Test Sentry Error
    </button>
  );
};

// App root component
const AppContent = () => {
  return (
    <>
      <EnvironmentBanner />

      <Suspense fallback={<PageLoader />}>
        {import.meta.env.PROD ? <SentryRouterProviderWrapper /> : <RouterProvider router={router} />}

        <SpeedInsights />
      </Suspense>
    </>
  );
};

export function App() {
  return <AppContent />;
}

// Sentry wrapper component that's only used in production
const SentryRouterProviderWrapper = () => {
  // We need to use dynamic import to properly use Sentry in production
  const SentryComponent = lazy(async () => {
    // Create the wrapped component
    const SentryRouterProvider = Sentry.withErrorBoundary(RouterProvider, {
      fallback: <div>An error has occurred</div>,
    });

    // Return as a React component
    return {
      default: () => <SentryRouterProvider router={router} />,
    };
  });

  return (
    <Suspense fallback={<PageLoader />}>
      <SentryComponent />
    </Suspense>
  );
};
